@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import com.varabyte.kobweb.browser.http.http
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.core.`init`.InitKobwebContext
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Suppress
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.dom.hasClass
import kotlinx.dom.removeClass
import org.jetbrains.compose.web.renderComposable
import org.w3c.dom.EventSource
import org.w3c.dom.EventSourceInit
import org.w3c.dom.MessageEvent
import org.w3c.dom.`get`
import com.arena_web.generated.City_aarhus as _com_arena_web_generated_City_aarhus
import com.arena_web.generated.City_alicante as _com_arena_web_generated_City_alicante
import com.arena_web.generated.City_amsterdam as _com_arena_web_generated_City_amsterdam
import com.arena_web.generated.City_ankara as _com_arena_web_generated_City_ankara
import com.arena_web.generated.City_antalya as _com_arena_web_generated_City_antalya
import com.arena_web.generated.City_antwerp as _com_arena_web_generated_City_antwerp
import com.arena_web.generated.City_athens as _com_arena_web_generated_City_athens
import com.arena_web.generated.City_barcelona as _com_arena_web_generated_City_barcelona
import com.arena_web.generated.City_basel as _com_arena_web_generated_City_basel
import com.arena_web.generated.City_belgrade as _com_arena_web_generated_City_belgrade
import com.arena_web.generated.City_bergen as _com_arena_web_generated_City_bergen
import com.arena_web.generated.City_berlin as _com_arena_web_generated_City_berlin
import com.arena_web.generated.City_bilbao as _com_arena_web_generated_City_bilbao
import com.arena_web.generated.City_birmingham as _com_arena_web_generated_City_birmingham
import com.arena_web.generated.City_bologna as _com_arena_web_generated_City_bologna
import com.arena_web.generated.City_bordeaux as _com_arena_web_generated_City_bordeaux
import com.arena_web.generated.City_boston as _com_arena_web_generated_City_boston
import com.arena_web.generated.City_bratislava as _com_arena_web_generated_City_bratislava
import com.arena_web.generated.City_brno as _com_arena_web_generated_City_brno
import com.arena_web.generated.City_brussels as _com_arena_web_generated_City_brussels
import com.arena_web.generated.City_bucharest as _com_arena_web_generated_City_bucharest
import com.arena_web.generated.City_budapest as _com_arena_web_generated_City_budapest
import com.arena_web.generated.City_cherkasy as _com_arena_web_generated_City_cherkasy
import com.arena_web.generated.City_chernivtsi as _com_arena_web_generated_City_chernivtsi
import com.arena_web.generated.City_chicago as _com_arena_web_generated_City_chicago
import com.arena_web.generated.City_chisinau as _com_arena_web_generated_City_chisinau
import com.arena_web.generated.City_cluj_napoca as _com_arena_web_generated_City_cluj_napoca
import com.arena_web.generated.City_cologne as _com_arena_web_generated_City_cologne
import com.arena_web.generated.City_copenhagen as _com_arena_web_generated_City_copenhagen
import com.arena_web.generated.City_dallas as _com_arena_web_generated_City_dallas
import com.arena_web.generated.City_dnipro as _com_arena_web_generated_City_dnipro
import com.arena_web.generated.City_dublin as _com_arena_web_generated_City_dublin
import com.arena_web.generated.City_dusseldorf as _com_arena_web_generated_City_dusseldorf
import com.arena_web.generated.City_edinburgh as _com_arena_web_generated_City_edinburgh
import com.arena_web.generated.City_eindhoven as _com_arena_web_generated_City_eindhoven
import com.arena_web.generated.City_florence as _com_arena_web_generated_City_florence
import com.arena_web.generated.City_frankfurt as _com_arena_web_generated_City_frankfurt
import com.arena_web.generated.City_gdansk as _com_arena_web_generated_City_gdansk
import com.arena_web.generated.City_geneva as _com_arena_web_generated_City_geneva
import com.arena_web.generated.City_glasgow as _com_arena_web_generated_City_glasgow
import com.arena_web.generated.City_gothenburg as _com_arena_web_generated_City_gothenburg
import com.arena_web.generated.City_granada as _com_arena_web_generated_City_granada
import com.arena_web.generated.City_graz as _com_arena_web_generated_City_graz
import com.arena_web.generated.City_hamburg as _com_arena_web_generated_City_hamburg
import com.arena_web.generated.City_helsinki as _com_arena_web_generated_City_helsinki
import com.arena_web.generated.City_houston as _com_arena_web_generated_City_houston
import com.arena_web.generated.City_istanbul as _com_arena_web_generated_City_istanbul
import com.arena_web.generated.City_ivano_frankivsk as _com_arena_web_generated_City_ivano_frankivsk
import com.arena_web.generated.City_izmir as _com_arena_web_generated_City_izmir
import com.arena_web.generated.City_katowice as _com_arena_web_generated_City_katowice
import com.arena_web.generated.City_kharkiv as _com_arena_web_generated_City_kharkiv
import com.arena_web.generated.City_khmelnytskyi as _com_arena_web_generated_City_khmelnytskyi
import com.arena_web.generated.City_krakow as _com_arena_web_generated_City_krakow
import com.arena_web.generated.City_kropyvnytskyi as _com_arena_web_generated_City_kropyvnytskyi
import com.arena_web.generated.City_kryvyi_rih as _com_arena_web_generated_City_kryvyi_rih
import com.arena_web.generated.City_kyiv as _com_arena_web_generated_City_kyiv
import com.arena_web.generated.City_las_palmas as _com_arena_web_generated_City_las_palmas
import com.arena_web.generated.City_leeds as _com_arena_web_generated_City_leeds
import com.arena_web.generated.City_leipzig as _com_arena_web_generated_City_leipzig
import com.arena_web.generated.City_lille as _com_arena_web_generated_City_lille
import com.arena_web.generated.City_limassol as _com_arena_web_generated_City_limassol
import com.arena_web.generated.City_linz as _com_arena_web_generated_City_linz
import com.arena_web.generated.City_lisbon as _com_arena_web_generated_City_lisbon
import com.arena_web.generated.City_liverpool as _com_arena_web_generated_City_liverpool
import com.arena_web.generated.City_ljubljana as _com_arena_web_generated_City_ljubljana
import com.arena_web.generated.City_lodz as _com_arena_web_generated_City_lodz
import com.arena_web.generated.City_london as _com_arena_web_generated_City_london
import com.arena_web.generated.City_los_angeles as _com_arena_web_generated_City_los_angeles
import com.arena_web.generated.City_lutsk as _com_arena_web_generated_City_lutsk
import com.arena_web.generated.City_luxembourg as _com_arena_web_generated_City_luxembourg
import com.arena_web.generated.City_lviv as _com_arena_web_generated_City_lviv
import com.arena_web.generated.City_lyon as _com_arena_web_generated_City_lyon
import com.arena_web.generated.City_madrid as _com_arena_web_generated_City_madrid
import com.arena_web.generated.City_malaga as _com_arena_web_generated_City_malaga
import com.arena_web.generated.City_malmo as _com_arena_web_generated_City_malmo
import com.arena_web.generated.City_malta as _com_arena_web_generated_City_malta
import com.arena_web.generated.City_manchester as _com_arena_web_generated_City_manchester
import com.arena_web.generated.City_marseille as _com_arena_web_generated_City_marseille
import com.arena_web.generated.City_miami as _com_arena_web_generated_City_miami
import com.arena_web.generated.City_milan as _com_arena_web_generated_City_milan
import com.arena_web.generated.City_munich as _com_arena_web_generated_City_munich
import com.arena_web.generated.City_murcia as _com_arena_web_generated_City_murcia
import com.arena_web.generated.City_mykolaiv as _com_arena_web_generated_City_mykolaiv
import com.arena_web.generated.City_naples as _com_arena_web_generated_City_naples
import com.arena_web.generated.City_new_york as _com_arena_web_generated_City_new_york
import com.arena_web.generated.City_nice as _com_arena_web_generated_City_nice
import com.arena_web.generated.City_nicosia as _com_arena_web_generated_City_nicosia
import com.arena_web.generated.City_odesa as _com_arena_web_generated_City_odesa
import com.arena_web.generated.City_oslo as _com_arena_web_generated_City_oslo
import com.arena_web.generated.City_ostrava as _com_arena_web_generated_City_ostrava
import com.arena_web.generated.City_palma as _com_arena_web_generated_City_palma
import com.arena_web.generated.City_paris as _com_arena_web_generated_City_paris
import com.arena_web.generated.City_philadelphia as _com_arena_web_generated_City_philadelphia
import com.arena_web.generated.City_phoenix as _com_arena_web_generated_City_phoenix
import com.arena_web.generated.City_podgorica as _com_arena_web_generated_City_podgorica
import com.arena_web.generated.City_poltava as _com_arena_web_generated_City_poltava
import com.arena_web.generated.City_porto as _com_arena_web_generated_City_porto
import com.arena_web.generated.City_poznan as _com_arena_web_generated_City_poznan
import com.arena_web.generated.City_prague as _com_arena_web_generated_City_prague
import com.arena_web.generated.City_pristina as _com_arena_web_generated_City_pristina
import com.arena_web.generated.City_reykjavik as _com_arena_web_generated_City_reykjavik
import com.arena_web.generated.City_riga as _com_arena_web_generated_City_riga
import com.arena_web.generated.City_rivne as _com_arena_web_generated_City_rivne
import com.arena_web.generated.City_rome as _com_arena_web_generated_City_rome
import com.arena_web.generated.City_rotterdam as _com_arena_web_generated_City_rotterdam
import com.arena_web.generated.City_san_francisco as _com_arena_web_generated_City_san_francisco
import com.arena_web.generated.City_san_sebastian as _com_arena_web_generated_City_san_sebastian
import com.arena_web.generated.City_sarajevo as _com_arena_web_generated_City_sarajevo
import com.arena_web.generated.City_sevilla as _com_arena_web_generated_City_sevilla
import com.arena_web.generated.City_skopje as _com_arena_web_generated_City_skopje
import com.arena_web.generated.City_sofia as _com_arena_web_generated_City_sofia
import com.arena_web.generated.City_stockholm as _com_arena_web_generated_City_stockholm
import com.arena_web.generated.City_stuttgart as _com_arena_web_generated_City_stuttgart
import com.arena_web.generated.City_tallinn as _com_arena_web_generated_City_tallinn
import com.arena_web.generated.City_tbilisi as _com_arena_web_generated_City_tbilisi
import com.arena_web.generated.City_ternopil as _com_arena_web_generated_City_ternopil
import com.arena_web.generated.City_the_hague as _com_arena_web_generated_City_the_hague
import com.arena_web.generated.City_thessaloniki as _com_arena_web_generated_City_thessaloniki
import com.arena_web.generated.City_tirana as _com_arena_web_generated_City_tirana
import com.arena_web.generated.City_toulouse as _com_arena_web_generated_City_toulouse
import com.arena_web.generated.City_turin as _com_arena_web_generated_City_turin
import com.arena_web.generated.City_utrecht as _com_arena_web_generated_City_utrecht
import com.arena_web.generated.City_uzhhorod as _com_arena_web_generated_City_uzhhorod
import com.arena_web.generated.City_valencia as _com_arena_web_generated_City_valencia
import com.arena_web.generated.City_valladolid as _com_arena_web_generated_City_valladolid
import com.arena_web.generated.City_vienna as _com_arena_web_generated_City_vienna
import com.arena_web.generated.City_vigo as _com_arena_web_generated_City_vigo
import com.arena_web.generated.City_vilnius as _com_arena_web_generated_City_vilnius
import com.arena_web.generated.City_vinnytsia as _com_arena_web_generated_City_vinnytsia
import com.arena_web.generated.City_warsaw as _com_arena_web_generated_City_warsaw
import com.arena_web.generated.City_wroclaw as _com_arena_web_generated_City_wroclaw
import com.arena_web.generated.City_zagreb as _com_arena_web_generated_City_zagreb
import com.arena_web.generated.City_zaporizhzhia as _com_arena_web_generated_City_zaporizhzhia
import com.arena_web.generated.City_zaragoza as _com_arena_web_generated_City_zaragoza
import com.arena_web.generated.City_zhytomyr as _com_arena_web_generated_City_zhytomyr
import com.arena_web.generated.City_zurich as _com_arena_web_generated_City_zurich
import com.arena_web.pages.AboutPage as _com_arena_web_pages_AboutPage
import com.arena_web.pages.ArenaPage as _com_arena_web_pages_ArenaPage
import com.arena_web.pages.BasketballPage as _com_arena_web_pages_BasketballPage
import com.arena_web.pages.ChatPage as _com_arena_web_pages_ChatPage
import com.arena_web.pages.CitiesPage as _com_arena_web_pages_CitiesPage
import com.arena_web.pages.ClientsPage as _com_arena_web_pages_ClientsPage
import com.arena_web.pages.DashboardPage as _com_arena_web_pages_DashboardPage
import com.arena_web.pages.DeleteAccountPage as _com_arena_web_pages_DeleteAccountPage
import com.arena_web.pages.FeedPage as _com_arena_web_pages_FeedPage
import com.arena_web.pages.FootballPage as _com_arena_web_pages_FootballPage
import com.arena_web.pages.HomePage as _com_arena_web_pages_HomePage
import com.arena_web.pages.NewsPage as _com_arena_web_pages_NewsPage
import com.arena_web.pages.NotFoundPage as _com_arena_web_pages_NotFoundPage
import com.arena_web.pages.PadelPage as _com_arena_web_pages_PadelPage
import com.arena_web.pages.PeoplePage as _com_arena_web_pages_PeoplePage
import com.arena_web.pages.PricingPage as _com_arena_web_pages_PricingPage
import com.arena_web.pages.PrivacyPage as _com_arena_web_pages_PrivacyPage
import com.arena_web.pages.ProfilePage as _com_arena_web_pages_ProfilePage
import com.arena_web.pages.RefundPage as _com_arena_web_pages_RefundPage
import com.arena_web.pages.SchedulePage as _com_arena_web_pages_SchedulePage
import com.arena_web.pages.SettingsPage as _com_arena_web_pages_SettingsPage
import com.arena_web.pages.SportsPage as _com_arena_web_pages_SportsPage
import com.arena_web.pages.TennisPage as _com_arena_web_pages_TennisPage
import com.arena_web.pages.TermsPage as _com_arena_web_pages_TermsPage
import com.arena_web.pages.VolleyballPage as _com_arena_web_pages_VolleyballPage
import com.arena_web.pages.chat.ChatRoomPage as _com_arena_web_pages_chat_ChatRoomPage
import com.arena_web.pages.clubs.ClubDetailPage as _com_arena_web_pages_clubs_ClubDetailPage
import com.arena_web.pages.events.EventDetailPage as _com_arena_web_pages_events_EventDetailPage
import com.arena_web.pages.news.NewsArticlePage as _com_arena_web_pages_news_NewsArticlePage
import com.arena_web.pages.news.club.ClubDetailPage as _com_arena_web_pages_news_club_ClubDetailPage
import com.arena_web.pages.news.match.MatchDetailPage as _com_arena_web_pages_news_match_MatchDetailPage
import com.arena_web.pages.profile.UserProfilePage as _com_arena_web_pages_profile_UserProfilePage

private fun forceReloadNow() {
    window.stop()
    window.location.reload()
}

private fun handleServerStatusEvents() {
    val status = document.getElementById("status")!!
    var lastVersion: Int? = null
    var shouldReload = false

    val warningIcon = status.children[0]!!
    val spinnerIcon = status.children[1]!!
    val statusText = status.children[2]!!

    status.addEventListener("transitionend", {
        if (status.hasClass("fade-out")) {
            status.removeClass("fade-out")
            if (shouldReload) {
                forceReloadNow()
            }
        }
    })

    val eventSource = EventSource("/api/kobweb-status", EventSourceInit(true))
    eventSource.addEventListener("version", { evt ->
        val version = (evt as MessageEvent).data.toString().toInt()
        if (lastVersion == null) {
            lastVersion = version
        }
        if (lastVersion != version) {
            lastVersion = version
            if (document.asDynamic().hidden) {
                // Reload immediately when the page is not visible as the animation will not run
                forceReloadNow()
            } else if (status.className.isNotEmpty()) {
                shouldReload = true
            } else {
                // Not sure if we can get here but if we can't rely on the status transition
                // to reload we should do it ourselves.
                forceReloadNow()
            }
        }
    })

    eventSource.addEventListener("status", { evt ->
        val values: dynamic = JSON.parse<Any>((evt as MessageEvent).data.toString())
        val text = values.text as String
        val isError = (values.isError as String).toBoolean()
        if (text.isNotBlank()) {
            warningIcon.className = if (isError) "visible" else "hidden"
            spinnerIcon.className = if (isError) "hidden" else "visible"
            statusText.innerHTML = "<i>$text</i>"
            status.className = "fade-in"
        } else {
            if (status.className == "fade-in") {
                status.className = "fade-out"
            }
        }
    })

    eventSource.onerror = { eventSource.close() }
}

public fun main() {
    handleServerStatusEvents()

    window.http.logOnError = true

    AppGlobals.initialize(mapOf("title" to "Arena"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _com_arena_web_pages_HomePage()
        }
        ctx.router.register(
            "/404",
        ) { pageCtx -> 
            _com_arena_web_pages_NotFoundPage()
        }
        ctx.router.register(
            "/about",
        ) { pageCtx -> 
            _com_arena_web_pages_AboutPage()
        }
        ctx.router.register(
            "/arena",
        ) { pageCtx -> 
            _com_arena_web_pages_ArenaPage()
        }
        ctx.router.register(
            "/basketball",
        ) { pageCtx -> 
            _com_arena_web_pages_BasketballPage()
        }
        ctx.router.register(
            "/chat",
        ) { pageCtx -> 
            _com_arena_web_pages_ChatPage()
        }
        ctx.router.register(
            "/chat/{id}",
        ) { pageCtx -> 
            _com_arena_web_pages_chat_ChatRoomPage()
        }
        ctx.router.register(
            "/cities",
        ) { pageCtx -> 
            _com_arena_web_pages_CitiesPage()
        }
        ctx.router.register(
            "/cities/aarhus",
        ) { pageCtx -> 
            _com_arena_web_generated_City_aarhus()
        }
        ctx.router.register(
            "/cities/alicante",
        ) { pageCtx -> 
            _com_arena_web_generated_City_alicante()
        }
        ctx.router.register(
            "/cities/amsterdam",
        ) { pageCtx -> 
            _com_arena_web_generated_City_amsterdam()
        }
        ctx.router.register(
            "/cities/ankara",
        ) { pageCtx -> 
            _com_arena_web_generated_City_ankara()
        }
        ctx.router.register(
            "/cities/antalya",
        ) { pageCtx -> 
            _com_arena_web_generated_City_antalya()
        }
        ctx.router.register(
            "/cities/antwerp",
        ) { pageCtx -> 
            _com_arena_web_generated_City_antwerp()
        }
        ctx.router.register(
            "/cities/athens",
        ) { pageCtx -> 
            _com_arena_web_generated_City_athens()
        }
        ctx.router.register(
            "/cities/barcelona",
        ) { pageCtx -> 
            _com_arena_web_generated_City_barcelona()
        }
        ctx.router.register(
            "/cities/basel",
        ) { pageCtx -> 
            _com_arena_web_generated_City_basel()
        }
        ctx.router.register(
            "/cities/belgrade",
        ) { pageCtx -> 
            _com_arena_web_generated_City_belgrade()
        }
        ctx.router.register(
            "/cities/bergen",
        ) { pageCtx -> 
            _com_arena_web_generated_City_bergen()
        }
        ctx.router.register(
            "/cities/berlin",
        ) { pageCtx -> 
            _com_arena_web_generated_City_berlin()
        }
        ctx.router.register(
            "/cities/bilbao",
        ) { pageCtx -> 
            _com_arena_web_generated_City_bilbao()
        }
        ctx.router.register(
            "/cities/birmingham",
        ) { pageCtx -> 
            _com_arena_web_generated_City_birmingham()
        }
        ctx.router.register(
            "/cities/bologna",
        ) { pageCtx -> 
            _com_arena_web_generated_City_bologna()
        }
        ctx.router.register(
            "/cities/bordeaux",
        ) { pageCtx -> 
            _com_arena_web_generated_City_bordeaux()
        }
        ctx.router.register(
            "/cities/boston",
        ) { pageCtx -> 
            _com_arena_web_generated_City_boston()
        }
        ctx.router.register(
            "/cities/bratislava",
        ) { pageCtx -> 
            _com_arena_web_generated_City_bratislava()
        }
        ctx.router.register(
            "/cities/brno",
        ) { pageCtx -> 
            _com_arena_web_generated_City_brno()
        }
        ctx.router.register(
            "/cities/brussels",
        ) { pageCtx -> 
            _com_arena_web_generated_City_brussels()
        }
        ctx.router.register(
            "/cities/bucharest",
        ) { pageCtx -> 
            _com_arena_web_generated_City_bucharest()
        }
        ctx.router.register(
            "/cities/budapest",
        ) { pageCtx -> 
            _com_arena_web_generated_City_budapest()
        }
        ctx.router.register(
            "/cities/cherkasy",
        ) { pageCtx -> 
            _com_arena_web_generated_City_cherkasy()
        }
        ctx.router.register(
            "/cities/chernivtsi",
        ) { pageCtx -> 
            _com_arena_web_generated_City_chernivtsi()
        }
        ctx.router.register(
            "/cities/chicago",
        ) { pageCtx -> 
            _com_arena_web_generated_City_chicago()
        }
        ctx.router.register(
            "/cities/chisinau",
        ) { pageCtx -> 
            _com_arena_web_generated_City_chisinau()
        }
        ctx.router.register(
            "/cities/cluj-napoca",
        ) { pageCtx -> 
            _com_arena_web_generated_City_cluj_napoca()
        }
        ctx.router.register(
            "/cities/cologne",
        ) { pageCtx -> 
            _com_arena_web_generated_City_cologne()
        }
        ctx.router.register(
            "/cities/copenhagen",
        ) { pageCtx -> 
            _com_arena_web_generated_City_copenhagen()
        }
        ctx.router.register(
            "/cities/dallas",
        ) { pageCtx -> 
            _com_arena_web_generated_City_dallas()
        }
        ctx.router.register(
            "/cities/dnipro",
        ) { pageCtx -> 
            _com_arena_web_generated_City_dnipro()
        }
        ctx.router.register(
            "/cities/dublin",
        ) { pageCtx -> 
            _com_arena_web_generated_City_dublin()
        }
        ctx.router.register(
            "/cities/dusseldorf",
        ) { pageCtx -> 
            _com_arena_web_generated_City_dusseldorf()
        }
        ctx.router.register(
            "/cities/edinburgh",
        ) { pageCtx -> 
            _com_arena_web_generated_City_edinburgh()
        }
        ctx.router.register(
            "/cities/eindhoven",
        ) { pageCtx -> 
            _com_arena_web_generated_City_eindhoven()
        }
        ctx.router.register(
            "/cities/florence",
        ) { pageCtx -> 
            _com_arena_web_generated_City_florence()
        }
        ctx.router.register(
            "/cities/frankfurt",
        ) { pageCtx -> 
            _com_arena_web_generated_City_frankfurt()
        }
        ctx.router.register(
            "/cities/gdansk",
        ) { pageCtx -> 
            _com_arena_web_generated_City_gdansk()
        }
        ctx.router.register(
            "/cities/geneva",
        ) { pageCtx -> 
            _com_arena_web_generated_City_geneva()
        }
        ctx.router.register(
            "/cities/glasgow",
        ) { pageCtx -> 
            _com_arena_web_generated_City_glasgow()
        }
        ctx.router.register(
            "/cities/gothenburg",
        ) { pageCtx -> 
            _com_arena_web_generated_City_gothenburg()
        }
        ctx.router.register(
            "/cities/granada",
        ) { pageCtx -> 
            _com_arena_web_generated_City_granada()
        }
        ctx.router.register(
            "/cities/graz",
        ) { pageCtx -> 
            _com_arena_web_generated_City_graz()
        }
        ctx.router.register(
            "/cities/hamburg",
        ) { pageCtx -> 
            _com_arena_web_generated_City_hamburg()
        }
        ctx.router.register(
            "/cities/helsinki",
        ) { pageCtx -> 
            _com_arena_web_generated_City_helsinki()
        }
        ctx.router.register(
            "/cities/houston",
        ) { pageCtx -> 
            _com_arena_web_generated_City_houston()
        }
        ctx.router.register(
            "/cities/istanbul",
        ) { pageCtx -> 
            _com_arena_web_generated_City_istanbul()
        }
        ctx.router.register(
            "/cities/ivano-frankivsk",
        ) { pageCtx -> 
            _com_arena_web_generated_City_ivano_frankivsk()
        }
        ctx.router.register(
            "/cities/izmir",
        ) { pageCtx -> 
            _com_arena_web_generated_City_izmir()
        }
        ctx.router.register(
            "/cities/katowice",
        ) { pageCtx -> 
            _com_arena_web_generated_City_katowice()
        }
        ctx.router.register(
            "/cities/kharkiv",
        ) { pageCtx -> 
            _com_arena_web_generated_City_kharkiv()
        }
        ctx.router.register(
            "/cities/khmelnytskyi",
        ) { pageCtx -> 
            _com_arena_web_generated_City_khmelnytskyi()
        }
        ctx.router.register(
            "/cities/krakow",
        ) { pageCtx -> 
            _com_arena_web_generated_City_krakow()
        }
        ctx.router.register(
            "/cities/kropyvnytskyi",
        ) { pageCtx -> 
            _com_arena_web_generated_City_kropyvnytskyi()
        }
        ctx.router.register(
            "/cities/kryvyi-rih",
        ) { pageCtx -> 
            _com_arena_web_generated_City_kryvyi_rih()
        }
        ctx.router.register(
            "/cities/kyiv",
        ) { pageCtx -> 
            _com_arena_web_generated_City_kyiv()
        }
        ctx.router.register(
            "/cities/las-palmas",
        ) { pageCtx -> 
            _com_arena_web_generated_City_las_palmas()
        }
        ctx.router.register(
            "/cities/leeds",
        ) { pageCtx -> 
            _com_arena_web_generated_City_leeds()
        }
        ctx.router.register(
            "/cities/leipzig",
        ) { pageCtx -> 
            _com_arena_web_generated_City_leipzig()
        }
        ctx.router.register(
            "/cities/lille",
        ) { pageCtx -> 
            _com_arena_web_generated_City_lille()
        }
        ctx.router.register(
            "/cities/limassol",
        ) { pageCtx -> 
            _com_arena_web_generated_City_limassol()
        }
        ctx.router.register(
            "/cities/linz",
        ) { pageCtx -> 
            _com_arena_web_generated_City_linz()
        }
        ctx.router.register(
            "/cities/lisbon",
        ) { pageCtx -> 
            _com_arena_web_generated_City_lisbon()
        }
        ctx.router.register(
            "/cities/liverpool",
        ) { pageCtx -> 
            _com_arena_web_generated_City_liverpool()
        }
        ctx.router.register(
            "/cities/ljubljana",
        ) { pageCtx -> 
            _com_arena_web_generated_City_ljubljana()
        }
        ctx.router.register(
            "/cities/lodz",
        ) { pageCtx -> 
            _com_arena_web_generated_City_lodz()
        }
        ctx.router.register(
            "/cities/london",
        ) { pageCtx -> 
            _com_arena_web_generated_City_london()
        }
        ctx.router.register(
            "/cities/los-angeles",
        ) { pageCtx -> 
            _com_arena_web_generated_City_los_angeles()
        }
        ctx.router.register(
            "/cities/lutsk",
        ) { pageCtx -> 
            _com_arena_web_generated_City_lutsk()
        }
        ctx.router.register(
            "/cities/luxembourg",
        ) { pageCtx -> 
            _com_arena_web_generated_City_luxembourg()
        }
        ctx.router.register(
            "/cities/lviv",
        ) { pageCtx -> 
            _com_arena_web_generated_City_lviv()
        }
        ctx.router.register(
            "/cities/lyon",
        ) { pageCtx -> 
            _com_arena_web_generated_City_lyon()
        }
        ctx.router.register(
            "/cities/madrid",
        ) { pageCtx -> 
            _com_arena_web_generated_City_madrid()
        }
        ctx.router.register(
            "/cities/malaga",
        ) { pageCtx -> 
            _com_arena_web_generated_City_malaga()
        }
        ctx.router.register(
            "/cities/malmo",
        ) { pageCtx -> 
            _com_arena_web_generated_City_malmo()
        }
        ctx.router.register(
            "/cities/malta",
        ) { pageCtx -> 
            _com_arena_web_generated_City_malta()
        }
        ctx.router.register(
            "/cities/manchester",
        ) { pageCtx -> 
            _com_arena_web_generated_City_manchester()
        }
        ctx.router.register(
            "/cities/marseille",
        ) { pageCtx -> 
            _com_arena_web_generated_City_marseille()
        }
        ctx.router.register(
            "/cities/miami",
        ) { pageCtx -> 
            _com_arena_web_generated_City_miami()
        }
        ctx.router.register(
            "/cities/milan",
        ) { pageCtx -> 
            _com_arena_web_generated_City_milan()
        }
        ctx.router.register(
            "/cities/munich",
        ) { pageCtx -> 
            _com_arena_web_generated_City_munich()
        }
        ctx.router.register(
            "/cities/murcia",
        ) { pageCtx -> 
            _com_arena_web_generated_City_murcia()
        }
        ctx.router.register(
            "/cities/mykolaiv",
        ) { pageCtx -> 
            _com_arena_web_generated_City_mykolaiv()
        }
        ctx.router.register(
            "/cities/naples",
        ) { pageCtx -> 
            _com_arena_web_generated_City_naples()
        }
        ctx.router.register(
            "/cities/new-york",
        ) { pageCtx -> 
            _com_arena_web_generated_City_new_york()
        }
        ctx.router.register(
            "/cities/nice",
        ) { pageCtx -> 
            _com_arena_web_generated_City_nice()
        }
        ctx.router.register(
            "/cities/nicosia",
        ) { pageCtx -> 
            _com_arena_web_generated_City_nicosia()
        }
        ctx.router.register(
            "/cities/odesa",
        ) { pageCtx -> 
            _com_arena_web_generated_City_odesa()
        }
        ctx.router.register(
            "/cities/oslo",
        ) { pageCtx -> 
            _com_arena_web_generated_City_oslo()
        }
        ctx.router.register(
            "/cities/ostrava",
        ) { pageCtx -> 
            _com_arena_web_generated_City_ostrava()
        }
        ctx.router.register(
            "/cities/palma",
        ) { pageCtx -> 
            _com_arena_web_generated_City_palma()
        }
        ctx.router.register(
            "/cities/paris",
        ) { pageCtx -> 
            _com_arena_web_generated_City_paris()
        }
        ctx.router.register(
            "/cities/philadelphia",
        ) { pageCtx -> 
            _com_arena_web_generated_City_philadelphia()
        }
        ctx.router.register(
            "/cities/phoenix",
        ) { pageCtx -> 
            _com_arena_web_generated_City_phoenix()
        }
        ctx.router.register(
            "/cities/podgorica",
        ) { pageCtx -> 
            _com_arena_web_generated_City_podgorica()
        }
        ctx.router.register(
            "/cities/poltava",
        ) { pageCtx -> 
            _com_arena_web_generated_City_poltava()
        }
        ctx.router.register(
            "/cities/porto",
        ) { pageCtx -> 
            _com_arena_web_generated_City_porto()
        }
        ctx.router.register(
            "/cities/poznan",
        ) { pageCtx -> 
            _com_arena_web_generated_City_poznan()
        }
        ctx.router.register(
            "/cities/prague",
        ) { pageCtx -> 
            _com_arena_web_generated_City_prague()
        }
        ctx.router.register(
            "/cities/pristina",
        ) { pageCtx -> 
            _com_arena_web_generated_City_pristina()
        }
        ctx.router.register(
            "/cities/reykjavik",
        ) { pageCtx -> 
            _com_arena_web_generated_City_reykjavik()
        }
        ctx.router.register(
            "/cities/riga",
        ) { pageCtx -> 
            _com_arena_web_generated_City_riga()
        }
        ctx.router.register(
            "/cities/rivne",
        ) { pageCtx -> 
            _com_arena_web_generated_City_rivne()
        }
        ctx.router.register(
            "/cities/rome",
        ) { pageCtx -> 
            _com_arena_web_generated_City_rome()
        }
        ctx.router.register(
            "/cities/rotterdam",
        ) { pageCtx -> 
            _com_arena_web_generated_City_rotterdam()
        }
        ctx.router.register(
            "/cities/san-francisco",
        ) { pageCtx -> 
            _com_arena_web_generated_City_san_francisco()
        }
        ctx.router.register(
            "/cities/san-sebastian",
        ) { pageCtx -> 
            _com_arena_web_generated_City_san_sebastian()
        }
        ctx.router.register(
            "/cities/sarajevo",
        ) { pageCtx -> 
            _com_arena_web_generated_City_sarajevo()
        }
        ctx.router.register(
            "/cities/sevilla",
        ) { pageCtx -> 
            _com_arena_web_generated_City_sevilla()
        }
        ctx.router.register(
            "/cities/skopje",
        ) { pageCtx -> 
            _com_arena_web_generated_City_skopje()
        }
        ctx.router.register(
            "/cities/sofia",
        ) { pageCtx -> 
            _com_arena_web_generated_City_sofia()
        }
        ctx.router.register(
            "/cities/stockholm",
        ) { pageCtx -> 
            _com_arena_web_generated_City_stockholm()
        }
        ctx.router.register(
            "/cities/stuttgart",
        ) { pageCtx -> 
            _com_arena_web_generated_City_stuttgart()
        }
        ctx.router.register(
            "/cities/tallinn",
        ) { pageCtx -> 
            _com_arena_web_generated_City_tallinn()
        }
        ctx.router.register(
            "/cities/tbilisi",
        ) { pageCtx -> 
            _com_arena_web_generated_City_tbilisi()
        }
        ctx.router.register(
            "/cities/ternopil",
        ) { pageCtx -> 
            _com_arena_web_generated_City_ternopil()
        }
        ctx.router.register(
            "/cities/the-hague",
        ) { pageCtx -> 
            _com_arena_web_generated_City_the_hague()
        }
        ctx.router.register(
            "/cities/thessaloniki",
        ) { pageCtx -> 
            _com_arena_web_generated_City_thessaloniki()
        }
        ctx.router.register(
            "/cities/tirana",
        ) { pageCtx -> 
            _com_arena_web_generated_City_tirana()
        }
        ctx.router.register(
            "/cities/toulouse",
        ) { pageCtx -> 
            _com_arena_web_generated_City_toulouse()
        }
        ctx.router.register(
            "/cities/turin",
        ) { pageCtx -> 
            _com_arena_web_generated_City_turin()
        }
        ctx.router.register(
            "/cities/utrecht",
        ) { pageCtx -> 
            _com_arena_web_generated_City_utrecht()
        }
        ctx.router.register(
            "/cities/uzhhorod",
        ) { pageCtx -> 
            _com_arena_web_generated_City_uzhhorod()
        }
        ctx.router.register(
            "/cities/valencia",
        ) { pageCtx -> 
            _com_arena_web_generated_City_valencia()
        }
        ctx.router.register(
            "/cities/valladolid",
        ) { pageCtx -> 
            _com_arena_web_generated_City_valladolid()
        }
        ctx.router.register(
            "/cities/vienna",
        ) { pageCtx -> 
            _com_arena_web_generated_City_vienna()
        }
        ctx.router.register(
            "/cities/vigo",
        ) { pageCtx -> 
            _com_arena_web_generated_City_vigo()
        }
        ctx.router.register(
            "/cities/vilnius",
        ) { pageCtx -> 
            _com_arena_web_generated_City_vilnius()
        }
        ctx.router.register(
            "/cities/vinnytsia",
        ) { pageCtx -> 
            _com_arena_web_generated_City_vinnytsia()
        }
        ctx.router.register(
            "/cities/warsaw",
        ) { pageCtx -> 
            _com_arena_web_generated_City_warsaw()
        }
        ctx.router.register(
            "/cities/wroclaw",
        ) { pageCtx -> 
            _com_arena_web_generated_City_wroclaw()
        }
        ctx.router.register(
            "/cities/zagreb",
        ) { pageCtx -> 
            _com_arena_web_generated_City_zagreb()
        }
        ctx.router.register(
            "/cities/zaporizhzhia",
        ) { pageCtx -> 
            _com_arena_web_generated_City_zaporizhzhia()
        }
        ctx.router.register(
            "/cities/zaragoza",
        ) { pageCtx -> 
            _com_arena_web_generated_City_zaragoza()
        }
        ctx.router.register(
            "/cities/zhytomyr",
        ) { pageCtx -> 
            _com_arena_web_generated_City_zhytomyr()
        }
        ctx.router.register(
            "/cities/zurich",
        ) { pageCtx -> 
            _com_arena_web_generated_City_zurich()
        }
        ctx.router.register(
            "/clients",
        ) { pageCtx -> 
            _com_arena_web_pages_ClientsPage()
        }
        ctx.router.register(
            "/clubs/{id}",
        ) { pageCtx -> 
            _com_arena_web_pages_clubs_ClubDetailPage()
        }
        ctx.router.register(
            "/dashboard",
        ) { pageCtx -> 
            _com_arena_web_pages_DashboardPage()
        }
        ctx.router.register(
            "/delete-account",
        ) { pageCtx -> 
            _com_arena_web_pages_DeleteAccountPage()
        }
        ctx.router.register(
            "/events/{id}",
        ) { pageCtx -> 
            _com_arena_web_pages_events_EventDetailPage()
        }
        ctx.router.register(
            "/feed",
        ) { pageCtx -> 
            _com_arena_web_pages_FeedPage()
        }
        ctx.router.register(
            "/football",
        ) { pageCtx -> 
            _com_arena_web_pages_FootballPage()
        }
        ctx.router.register(
            "/news",
        ) { pageCtx -> 
            _com_arena_web_pages_NewsPage()
        }
        ctx.router.register(
            "/news/club/{id}",
        ) { pageCtx -> 
            _com_arena_web_pages_news_club_ClubDetailPage()
        }
        ctx.router.register(
            "/news/match/{id}",
        ) { pageCtx -> 
            _com_arena_web_pages_news_match_MatchDetailPage()
        }
        ctx.router.register(
            "/news/{id}",
        ) { pageCtx -> 
            _com_arena_web_pages_news_NewsArticlePage()
        }
        ctx.router.register(
            "/padel",
        ) { pageCtx -> 
            _com_arena_web_pages_PadelPage()
        }
        ctx.router.register(
            "/people",
        ) { pageCtx -> 
            _com_arena_web_pages_PeoplePage()
        }
        ctx.router.register(
            "/pricing",
        ) { pageCtx -> 
            _com_arena_web_pages_PricingPage()
        }
        ctx.router.register(
            "/privacy",
        ) { pageCtx -> 
            _com_arena_web_pages_PrivacyPage()
        }
        ctx.router.register(
            "/profile",
        ) { pageCtx -> 
            _com_arena_web_pages_ProfilePage()
        }
        ctx.router.register(
            "/profile/{id}",
        ) { pageCtx -> 
            _com_arena_web_pages_profile_UserProfilePage()
        }
        ctx.router.register(
            "/refund",
        ) { pageCtx -> 
            _com_arena_web_pages_RefundPage()
        }
        ctx.router.register(
            "/schedule",
        ) { pageCtx -> 
            _com_arena_web_pages_SchedulePage()
        }
        ctx.router.register(
            "/settings",
        ) { pageCtx -> 
            _com_arena_web_pages_SettingsPage()
        }
        ctx.router.register(
            "/sports",
        ) { pageCtx -> 
            _com_arena_web_pages_SportsPage()
        }
        ctx.router.register(
            "/tennis",
        ) { pageCtx -> 
            _com_arena_web_pages_TennisPage()
        }
        ctx.router.register(
            "/terms",
        ) { pageCtx -> 
            _com_arena_web_pages_TermsPage()
        }
        ctx.router.register(
            "/volleyball",
        ) { pageCtx -> 
            _com_arena_web_pages_VolleyballPage()
        }

        com.arena_web.initKobweb(ctx)
    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("back-to-top-button", com.arena_web.ui.components.widgets.BackToTopButtonStyle)
        ctx.theme.registerStyle("arrow", com.arena_web.ui.components.widgets.ArrowStyle)
        ctx.theme.registerStyle("hidden-scrollbar", com.arena_web.ui.components.widgets.HiddenScrollbarStyle)
        ctx.theme.registerStyle("nav-header", com.arena_web.ui.sections.header.NavHeaderStyle)
        ctx.theme.registerStyle("nav-link", com.arena_web.ui.sections.header.NavLinkStyle)
        ctx.theme.registerStyle("icon-button", com.arena_web.ui.sections.header.IconButtonStyle)
        ctx.theme.registerKeyframes("expand-scale-in", com.arena_web.ui.components.overlay.ExpandScaleIn)
        ctx.theme.registerKeyframes("modal-fade-in", com.arena_web.ui.components.overlay.ModalFadeInKeyframes)
        ctx.theme.registerKeyframes("modal-overlay-fade-in", com.arena_web.ui.components.overlay.ModalOverlayFadeInKeyframes)
        ctx.theme.registerKeyframes("snackbar-slide-down", com.arena_web.ui.components.notifications.SnackbarSlideDownKeyframes)
        ctx.theme.registerKeyframes("snackbar-slide-up", com.arena_web.ui.components.notifications.SnackbarSlideUpKeyframes)
        ctx.theme.registerKeyframes("toast-slide-in", com.arena_web.ui.components.notifications.ToastSlideInKeyframes)
        ctx.theme.registerKeyframes("fade-in", com.arena_web.ui.components.widgets.FadeInKeyframes)
        ctx.theme.registerKeyframes("cookie-slide-up", com.arena_web.ui.components.widgets.CookieSlideUpKeyframes)
        ctx.theme.registerKeyframes("shimmer", com.arena_web.ui.components.widgets.ShimmerKeyframes)
        ctx.theme.registerKeyframes("popup-overlay-fade-in", com.arena_web.ui.components.events.PopupOverlayFadeIn)
        ctx.theme.registerKeyframes("popup-slide-up", com.arena_web.ui.components.events.PopupSlideUp)
        ctx.theme.registerKeyframes("info-rise", com.arena_web.ui.sections.info.InfoRiseKeyframes)
        ctx.theme.registerKeyframes("hero-chunk", com.arena_web.ui.sections.home.HeroChunkKeyframes)
        ctx.theme.registerKeyframes("hero-word-swap", com.arena_web.ui.sections.home.HeroWordSwapKeyframes)
        ctx.theme.registerKeyframes("hero-logo-intro", com.arena_web.ui.sections.home.HeroLogoIntroKeyframes)
        ctx.theme.registerKeyframes("hero-burst", com.arena_web.ui.sections.home.HeroBurstKeyframes)
        ctx.theme.registerKeyframes("brand-glyph-dock", com.arena_web.ui.sections.header.components.BrandGlyphDockKeyframes)
        ctx.theme.registerKeyframes("brand-wordmark-reveal", com.arena_web.ui.sections.header.components.BrandWordmarkRevealKeyframes)
        ctx.theme.registerKeyframes("side-menu-slide-in", com.arena_web.ui.sections.header.SideMenuSlideInAnim)
        com.arena_web.initSilk(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        com.arena_web.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
